import { Component } from '@angular/core';
import {  NavController, NavParams, ViewController } from 'ionic-angular';
import { BllOrtak } from '../../../providers/bll/bll-ortak';
import { Ortak } from '../../../providers/ortak';

/**
 * Generated class for the VaryantEkleGuncellePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

 
@Component({
  selector: 'page-varyant-ekle-guncelle',
  templateUrl: 'varyant-ekle-guncelle.html',
})
export class VaryantEkleGuncellePage {
  stok:any={ID:-1,StokAdi:"",Barcode1:"",VaryantAdi:"" };
  stokID:any={};

  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
    public ortak:Ortak,
    public viewCtrl:ViewController,
     public navParams: NavParams) {
      if (navParams.get("stok_id") != null) {
        this.stokID = navParams.get("stok_id");
        var data = new FormData();
        data.append("Stok_id", this.stokID);
        this.bllOrtak.islem(data, "StokGetirByID", "", false).then(a => {
          var Sonuc = <any>a;
          console.log("sonucListesi",Sonuc.SonucObject);
          this.stok = Sonuc.SonucObject;
         
        }
        )
      }
      if (navParams.get("bagliID") != null) {
        this.stokID = navParams.get("bagliID");
         
               }
  }

  ionViewDidLoad() {
    
  }
  boslukKontrol() {
    var mesaj = "";
    
    if (this.stok.VaryantAdi== null || this.stok.VaryantAdi== "") {
      mesaj = mesaj + "Lütfen Stok adını giriniz. <br/>";
    }

    if (mesaj == "") {
      return true;
    }
    else {
      this.ortak.showBasicAlert("Uyarı", mesaj);
      return false;
    }
  }
  kaydet() {

    var formData = new FormData();
   
    if (this.boslukKontrol()) {
      formData.append("stok_json", JSON.stringify(this.stok));
      formData.append("bagliID", this.stokID);
     
      console.log("stok_json", JSON.stringify(this.stok));
      console.log("bagliID", this.stokID);
    
      this.bllOrtak.islem(formData, "VaryantEkleGuncelle", "", false).then(a => {
        var sonuc = <any>a;
        if(sonuc.Sonuc==1) this.ortak.showBasicAlert("Başarılı","İşlem Başarılı");
       

      })
    }
    this.cikis();
    }
    cikis()
    {
      this.viewCtrl.dismiss();
    }

}



// WEBPACK FOOTER //
// ./src/pages/StokIslemleri/varyant-ekle-guncelle/varyant-ekle-guncelle.ts